import React, { useState, useMemo, useCallback } from 'react'
import { Stack, Divider, Typography } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';

import SearchBoard from '../../../../../myTask/components/Filters/SearchBoard';
import './CardAssignMobile.scss';
import FormDialog from '../../../../../../components/Dialog/FormDialog';
import { useCards } from '../../../../../../reactQuery/cards';
import useMutate from '../../../../../../hooks/useMutate';
import { updateParentCard } from '../../../../../../services/apiCards';
import { useQueryClient } from '@tanstack/react-query';

function MobileAssignParentCard({ onClose, card, cardId }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [loading, setLoading] = useState(false);
    const queryClient = useQueryClient();
  const { parent_card_id, board_id } = card;
  const { isLoading, cards, isError } = useCards(board_id);
  const data = cards?.data?.data?.responseData || [];

   const { mutate: updateCardmutate } = useMutate(
     updateParentCard,
     ["card", "mineCards", "watching"],
     () => {},
     () => {
       setLoading(false);
       queryClient.invalidateQueries({
         queryKey: [`cards`, String(board_id)],
       });
         setShowConfirmation(false);
         onClose();
     },
     () => {
       setLoading(false);
     }
   );

  const filteredCards = useMemo(
    () =>
      data?.filter(
        (item) =>
          item?.card?.card_id !== cardId &&
          item?.card?.card_id !== parent_card_id &&
          !item?.card?.parent_card_id &&
          !item?.sub_tasks?.some(
            (subtaskItem) => subtaskItem === item?.card?.card_id
          ) &&
          (item?.key + "-" + item?.card?.card_id + " " + item?.card?.title)
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
      ) || [],
    [data, cardId, parent_card_id, searchQuery]
  );

  const handleCardSelect = useCallback((card) => {
    setSelectedCard(card.card.card_id);
    setShowConfirmation(true);
  }, []);

   const handleChangeParent = useCallback(() => {
     setLoading(true);
     updateCardmutate({
       card_id: cardId,
       parent_card_id: selectedCard,
     });
   }, [cardId, selectedCard, updateCardmutate]);

  const submit = () => {
   handleChangeParent();
  };

  return (
    <div className="mobile-assign-parent-card-popup-container">
      <SearchBoard
        onSearch={(val) => setSearchQuery(val)}
        searchQuery={searchQuery}
      />
      {filteredCards?.length > 0 && (
        <div className="mobile-assign-parent-card-list-container">
          <Stack
            className="mobile-assign-parent-list"
            spacing={1}
            divider={<Divider className="m-0" orientation="horizontal" />}
          >
            {filteredCards?.map((card) => (
              <div
                key={card.card_id}
                onClick={() => handleCardSelect(card)}
                className="mobile-assign-parent-list-item"
              >
                <div>
                  <Typography className="card-id">{`${card.card.board_key}-${card.card.card_id}`}</Typography>
                  <Typography className="card-title">
                    {card.card.title}
                  </Typography>
                </div>
                <ArrowForwardIos className="icon" />
              </div>
            ))}
          </Stack>

          {showConfirmation && (
            <FormDialog
              open={showConfirmation}
              handleClose={() => setShowConfirmation(false)}
              handleSubmit={submit}
              buttonTxt="Assign"
              title="Assign Parent Task"
              cancelBtn={true}
              alignActions="center"
              fullWidth={true}
            >
              <Typography className="align_text_center mb-2">
                Are you sure you want to change parent task? This action cannot
                be undone.
              </Typography>
            </FormDialog>
          )}
        </div>
      )}
    </div>
  );
}

export default MobileAssignParentCard;